import React from 'react';
import styled from 'styled-components';
import { canvas, textSecondary, textPrimary, borderSubtle, borderDefault, danger, dangerLight } from '../../tokens/colors';
import { radiusMd } from '../../tokens/radii';
import { fontFamily } from '../../tokens/typography';

export const ActionBar = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  border-bottom: 0.5px solid ${borderSubtle};
  background: ${canvas};
`;

interface ActionButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'default' | 'danger';
  icon?: React.ReactNode;
}

const StyledActionButton = styled.button<{ $danger: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 5px 12px;
  font-size: 11px;
  font-family: ${fontFamily};
  cursor: pointer;
  border: 0.5px solid ${borderDefault};
  border-radius: ${radiusMd};
  background: transparent;
  color: ${textSecondary};
  white-space: nowrap;
  transition: background 0.1s, color 0.1s, border-color 0.1s;

  &:hover:not(:disabled) {
    background: ${({ $danger }) => $danger ? dangerLight : 'white'};
    color: ${({ $danger }) => $danger ? danger : textPrimary};
    border-color: ${({ $danger }) => $danger ? '#F09595' : borderDefault};
  }

  &:disabled { opacity: 0.45; cursor: not-allowed; }
`;

export const ActionButton: React.FC<ActionButtonProps> = ({ variant = 'default', icon, children, ...rest }) => (
  <StyledActionButton type="button" $danger={variant === 'danger'} {...rest}>
    {icon}
    {children}
  </StyledActionButton>
);
